import { type FC } from "react";
import { TextButton, type TextButtonProps } from "@/components/essentials/button";
import { copy } from "@/modules/utils/copy-to-clipboard";
import { Toast, useToast } from "@/components/essentials/toast";
import { copyButtonTestId, copyToastTestId, defaultFailMessage, defaultSuccessMessage } from "./const";

export type CopyClipboardButtonProps = Partial<TextButtonProps> & {
  copyValue: string;
  successMessage?: string;
  failMessage?: string;
};

export const CopyClipboardButton: FC<CopyClipboardButtonProps> = ({
  copyValue,
  successMessage = defaultSuccessMessage,
  failMessage = defaultFailMessage,
  ...restProps
}) => {
  const toast = useToast();
  const handleClick = (): void => {
    const result = copy(copyValue);
    toast({
      position: "bottom",
      render: () => (
        <Toast data-testid={copyToastTestId} variant={result ? "info" : "error"}>
          {result ? successMessage : failMessage}
        </Toast>
      ),
    });
  };

  return (
    <TextButton
      data-testid={copyButtonTestId}
      onClick={handleClick}
      color="theme.green.main"
      // biome-ignore lint/correctness/noChildrenProp :[AUTOMATICALLY-INSERTED] Avoid passing children using a prop
      children="コピー"
      {...restProps}
    />
  );
};
